import { TableCell } from 'Components/Table/Table/Table';
import { Text } from 'Components/Text/Text';

import styles from './PrimaryTextAndSecondaryTextTableCell.module.css';

export const PrimaryTextAndSecondaryTextTableCell = ({ primaryText, secondaryText }: { primaryText: string; secondaryText: string }) => {
    return (
        <TableCell className={styles.containerCell}>
            <div className={styles.primaryTextAndSecondaryText}>
                <Text noStyles>{primaryText}</Text>
                <Text noStyles color="darkGray">
                    {secondaryText}
                </Text>
            </div>
        </TableCell>
    );
};
